export interface OnlyAlphabeticValidationErrorProps {
  regex: RegExp;
}
export class OnlyAlphabeticValidationError
  implements OnlyAlphabeticValidationErrorProps
{
  constructor(public regex: RegExp) {}
}
